import { render, staticRenderFns } from "./IntranetLogout.vue?vue&type=template&id=6c429fec&"
import script from "./IntranetLogout.vue?vue&type=script&lang=js&"
export * from "./IntranetLogout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports